import React from 'react'

const HomeInfo = () => {
    return (
        <>
            <section className="cyta-technologies">
                <div className="container">
                    <div className="technology-main">
                        <div className="technolog-content">
                            <p>CYTA Technologies provides innovative technology solutions for businesses, from <span
                                className="hov-x"> website
                                design </span> and <span className="hov-x">e-commerce</span> to mobile app development
                                and custom software, with a dynamic team
                                of experts passionate about <span className="n-x">staying up-to-date with the latest
                                    advancements.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HomeInfo